import {Controller} from "stimulus"

export default class extends Controller {
    static get targets() {
        return ["period", "scenario", "scenarioAction"]
    }

    get periodTarget() {
        return this.targets.find("period")
    }

    get scenarioTarget() {
        return this.targets.find("scenario")
    }

    reloadPage(event) {
        const target = event.target
        const form = document.createElement("form")
        form.method = "post"
        form.action = target.closest("form").action

        const input = document.createElement("input")
        input.type = "hidden"
        input.name = target.name
        input.value = target.value
        form.appendChild(input)

        document.body.appendChild(form)
        form.requestSubmit()
    }
}